import CustomerDetails from "./CustomerDetails";

export default CustomerDetails;
